import { colors, fontWeight } from '@cobliteam/ui/theme';
import { css } from 'emotion';

export const controlButton = css`
  min-height: 30px;
  min-width: 30px;
  box-shadow: 0 0 10px 0 ${colors.gray.a4};

  & > svg {
    margin: auto;
    font-size: $icons.size.medium;
  }
`;

export const controlButtonText = css`
  font-weight: ${fontWeight.bold};
  margin: auto;

  &:not(:first-child) {
    margin-left: 10px;
  }
`;
